// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__fFwWy","checkbox-wrapper":"Variant_checkbox-wrapper__NoMe-","checkbox":"Variant_checkbox__7RkJq","variant-body":"Variant_variant-body__PPUe4"};